<template>
  <section class="section">
    <div class="colums">
      <div class="column is-paddingless">
        <h1 class="title">Reminders and Planned Maintenance</h1>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Reminders',
};
</script>

<style scoped>

</style>
